import React, { useEffect, useState } from "react";
import EventsItem from "../Events/EventsItem";

import { getPastEvents } from "../../../scripts/dataHandlers";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

export default function PastEvents(props) {
    const [allEvents, setallEvents] = useState(null);
    const { t } = useTranslation();

    // if we need to show events from sub-organization
    const { subOrganizationId } = useParams();

    const { limit } = props.settings;

    useEffect(() => {
        const runFunction = async () => {
            try {
                const res1 = await getPastEvents(subOrganizationId ? subOrganizationId : props.organizationId, limit);

                if (res1.data.status === "ok") {
                    setallEvents(res1.data.events);
                }
            } catch (error) {
                console.log(error);
            }
        };

        props.organizationId && runFunction();
    }, [props.organizationId, limit, subOrganizationId]);
    return (
        // If it includes props(upcomingEventCategory) , it means it wont have any category id or name and we have to fetch filter data and route accordingly
        allEvents &&
        allEvents.length > 0 && (
            <EventsItem
                allEvents={allEvents}
                heading={t("eventsCategory.pastEvents")}
                upcomingEventCategory={true}
                organizationId={subOrganizationId ? subOrganizationId : props.organizationId}
                homepageContainer={props.homepageContainer}
                extraClassname={props.extraClassname}
                hideViewAll={props.hideViewAll}
                styles={props.styles}
                accessedbyAdmin={props.accessedbyAdmin}
                viewAllRoute={`/events/Past Events/${subOrganizationId ? subOrganizationId : props.organizationId}/pastEvent`}
            />
        )
    );
}
